module.exports = __webpack_public_path__ + "static/assets/5f84f492b7d19a49a68c614957bb0a77.svg";